'use client'

import type { EmbeddedScriptProps } from '@pearlconvert/ui/components/embedded-script/embedded-script.types'

import React from 'react'

import { useEmbeddedScript } from '@pearlconvert/ui/components/embedded-script/batons/use-embedded-script'

export default function EmbeddedScript(props: EmbeddedScriptProps) {
  const { code } = props

  const { containerRef } = useEmbeddedScript({ code })

  return <div ref={containerRef} />
}
